/* @flow */
import * as React from 'react';

const StarViolet = props => (
  <svg width={15} height={14} viewBox="0 0 15 14" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      fillRule="evenodd"
      d="M14.5,4.965 L9.512,4.965 L7.974,0.342 C7.906,0.137 7.715,0 7.5,0 C7.285,0 7.094,0.137 7.026,0.342 L5.488,4.965 L0.5,4.965 C0.282,4.965 0.09,5.106 0.024,5.313 C-0.042,5.521 0.034,5.747 0.211,5.873 L4.235,8.728 L2.7,13.342 C2.632,13.547 2.703,13.773 2.877,13.902 C3.05,14.03 3.287,14.033 3.463,13.908 L7.5,11.044 L11.537,13.908 C11.623,13.969 11.725,14 11.826,14 C11.93,14 12.035,13.967 12.123,13.902 C12.297,13.773 12.368,13.547 12.3,13.342 L10.765,8.728 L14.789,5.873 C14.966,5.747 15.042,5.521 14.976,5.313 C14.91,5.106 14.718,4.965 14.5,4.965 Z"
    />
  </svg>
);

export default StarViolet;



// WEBPACK FOOTER //
// ./src/assets/images/icons/star-violet.js